import delegate from '../../00-utilities/delegate';
import DropdownBase from "./DropdownBase";

export default class DropdownList extends DropdownBase {
  constructor() {
    super();
    // Open Dropdown List
    delegate({
      target: '.dropdown--list .dropdown__trigger',
      listener: this.onClickDropdownListHeader.bind(this),
      event: 'click',
    });


    // Init Nav Dropdown
    this.initAllNavDropdown();

    this.setMinWidthToParent();
  }

  /**
   * Init All .dropdown type list
   * @param {Object} Event
   */
  initAllNavDropdown() {
    let dropdowns = document.querySelectorAll('nav.dropdown');

    for(let ii = 0; ii < dropdowns.length; ii++) {
      dropdowns[ii].classList.add('dropdown--list');
      let links = dropdowns[ii].querySelectorAll('.dropdown__link,.dropdown__trigger');

      // Scan for svg
      for(let jj = 0; jj < links.length ; jj++) {
        let svgs = links[jj].querySelectorAll('svg');

        // Detach them
        for( let kk = 0; kk < svgs.length ; kk++) {
          links[jj].removeChild(svgs[kk])
        }

        let tempHtml = `<span class="dropdown__text-item">
                          ${links[jj].innerHTML}
                        </span>`;

        for( let kk = 0; kk < svgs.length ; kk++) {
          if(svgs[kk].classList.contains('icon--left')) {
            tempHtml = svgs[kk].outerHTML + tempHtml;
          }
          else if (svgs[kk].classList.contains('icon--left')) {
            tempHtml = tempHtml + svgs[kk].outerHTML;
          }
        }
        links[jj].innerHTML = tempHtml;
      }
    }
  }

  /**
   * Open .dropdown__content with Dropdown type list
   * @param {Object} Event
   */
  onClickDropdownListHeader(e) {
    if(document.querySelector('.dropdown.js--active') ){
      return true;
    }
    e.target.parentElement.classList.add('js--active');
    const dropdownContent = e.target.nextElementSibling;
    this.setOnTimeOutTransitionEndDropdownContent(dropdownContent);
    this.removeListenerOnBodyClick();
    this.addListenerOnBodyClick();
  }
}
